<template>
    <div>
        <div v-show="show" class="mb-8">
            <!-- shows if... ? -->
            <header class="px-5 py-4">
                <h2 class="font-semibold text-gray-800">
                    {{ user.name }}'s Cards
                    <span class="text-gray-400 font-medium text-sm">
                        ({{ user.numFilteredCards }})
                    </span>
                </h2>
            </header>
            <!-- START EMPTY STATE (no institutions for user) -->
            <div v-if="loaded && user.institutions.length === 0">
                <div
                    class="bg-white overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg mb-5 py-10"
                >
                    <div class="container mx-auto max-w-6xl px-4 py-4">
                        <div class="max-w-2xl rx m-auto">
                            <div class="text-center px-4">
                                <div
                                    class="flex items-center justify-center rounded-full mb-4"
                                >
                                    <svg
                                        class="w-24"
                                        version="1.1"
                                        viewBox="0 0 60 60"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                    >
                                        <defs>
                                            <linearGradient
                                                id="e"
                                                x1="50%"
                                                x2="50%"
                                                y2="100%"
                                            >
                                                <stop
                                                    stop-color="#F3F5F9"
                                                    offset="0"
                                                />
                                                <stop
                                                    stop-color="#E2E8F0"
                                                    offset="1"
                                                />
                                            </linearGradient>
                                            <rect
                                                id="b"
                                                width="60"
                                                height="60"
                                                rx="30"
                                            />
                                            <polygon
                                                id="c"
                                                points="0 0 8.4211 0 8.4211 11.579 0 11.579"
                                            />
                                        </defs>
                                        <g fill="none" fill-rule="evenodd">
                                            <g transform="translate(-850 -303)">
                                                <g
                                                    transform="translate(560 303)"
                                                >
                                                    <g
                                                        transform="translate(290)"
                                                    >
                                                        <mask
                                                            id="a"
                                                            fill="white"
                                                        >
                                                            <use
                                                                xlink:href="#b"
                                                            />
                                                        </mask>
                                                        <use
                                                            fill="url(#e)"
                                                            xlink:href="#b"
                                                        />
                                                        <path
                                                            d="m15.217 28.895h-5.2171c0.28876-4.4211 2.0367-8.4442 4.7599-11.579l3.6611 3.7247c-1.7792 2.1703-2.9395 4.8827-3.204 7.8543"
                                                            fill="#F27249"
                                                            mask="url(#a)"
                                                        />
                                                        <path
                                                            d="m27.895 16.184c-2.9736 0.26723-5.6877 1.4393-7.8595 3.2366l-3.7194-3.6906c3.1426-2.7076 7.1637-4.4432 11.579-4.7304v5.1844z"
                                                            fill="#FD411D"
                                                            mask="url(#a)"
                                                        />
                                                        <path
                                                            d="m32.226 32.672c-0.462 0.90249-1.4673 1.4856-2.561 1.4856-1.5565 0-2.8228-1.1519-2.8228-2.5678 0-0.88186 0.48882-1.692 1.3076-2.1671l8.1661-4.7388-4.0899 7.9881z"
                                                            fill="#FD411D"
                                                            mask="url(#a)"
                                                        />
                                                        <path
                                                            d="m38.912 19.421c-2.1719-1.7972-4.8862-2.9693-7.8599-3.2365v-5.1846c4.4154 0.2872 8.4362 2.0235 11.579 4.7311l-3.7191 3.69z"
                                                            fill="#48B0D9"
                                                            mask="url(#a)"
                                                        />
                                                        <g mask="url(#a)">
                                                            <g
                                                                transform="translate(41.579 17.316)"
                                                            >
                                                                <mask
                                                                    id="d"
                                                                    fill="white"
                                                                >
                                                                    <use
                                                                        xlink:href="#c"
                                                                    />
                                                                </mask>
                                                                <path
                                                                    d="m3.2035 11.579c-0.26449-2.9715-1.4245-5.6838-3.2035-7.8542l3.6606-3.7248c2.7229 3.1348 4.4717 7.1579 4.7604 11.579h-5.2176z"
                                                                    fill="#213E4A"
                                                                    fill-rule="evenodd"
                                                                    mask="url(#d)"
                                                                />
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                </div>
                                <h2
                                    class="text-2xl text-gray-800 font-bold mb-3"
                                >
                                    Start Setting Up Your Wallet
                                </h2>
                                <div class="mb-12 relative">
                                    <p>
                                        Looks like your wallet is empty :( Get
                                        started by adding a card here.
                                        <svg
                                            version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            viewBox="0 0 43.1 85.9"
                                            style="
                                                enable-background: new 0 0 43.1
                                                    85.9;
                                            "
                                            xml:space="preserve"
                                            class="animated-arrow absolute top-6 right-0 lg:top-3 lg:right-20"
                                        >
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                class="st0 draw-arrow"
                                                d="M11.3,2.5c-5.8,5-8.7,12.7-9,20.3s2,15.1,5.3,22c6.7,14,18,25.8,31.7,33.1"
                                            />
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                class="draw-arrow tail-1"
                                                d="M40.6,78.1C39,71.3,37.2,64.6,35.2,58"
                                            />
                                            <path
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                class="draw-arrow tail-2"
                                                d="M39.8,78.5c-7.2,1.7-14.3,3.3-21.5,4.9"
                                            />
                                        </svg>
                                    </p>
                                </div>
                                <a
                                    href="#"
                                    class="btn-base btn-dark"
                                    @click.prevent="openConnectModal"
                                    role="button"
                                    id="hs-wallet-setup-wallet"
                                >
                                    <svg
                                        class="w-4 h-4 flex-shrink-0"
                                        viewBox="0 0 16 16"
                                        fill="#F27249"
                                    >
                                        <path
                                            d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z"
                                        />
                                    </svg>
                                    <span class="hidden xs:block ml-2">
                                        Setup Your Wallet
                                    </span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- END EMPTY STATE (no institutions for user) -->
            <!-- START TABLE -->
            <div
                v-for="(institution, ins) in user.institutions"
                :key="`inst-${ins}`"
                v-if="userAccountCount(user) > 0"
            >
                <WalletInstitution
                    :key="`inst-${ins}`"
                    :institution="institution"
                    :badMembers="badMembers"
                    :collapsedOnLoad="
                        collapsedInstitutions.includes(institution.id)
                    "
                    @toggle-collapse="handleToggleCollapse"
                />
            </div>

            <!-- END TABLE -->
            <!-- START EMPTY STATE (no cards matching filters) -->
            <EmptyState
                v-if="
                    user.institutions.length > 0 && user.numFilteredCards === 0
                "
                title="No matching cards found for this user."
                description="Try adjusting your filter criteria or clearing the filters to view more cards."
                action-label="Reset Filters"
                @action="() => $emit('clearFilters')"
            />
            <!-- END EMPTY STATE (no cards matching filters) -->
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useWalletStore } from '@/store/wallet';
import { useAppStore } from '@/store/app';
import EmptyState from '@/components/ui/empty-state/empty-state.vue';
import WalletInstitution from '@/components/wallet/partials/wallet-institution/wallet-institution.vue';
import vClickOutside from 'click-outside-vue3';
import AnnualFee from '@/components/wallet/annual-fee.vue';
import Tooltip from '@/components/tooltip.vue';

export default {
    props: {
        wallet: Object,
        user: Object,
        // filters: Object,
        show: Boolean,
    },
    components: {
        AnnualFee,
        EmptyState,
        Tooltip,
        WalletInstitution,
    },

    data: () => ({
        showEditCardModal: false,
        card: {},
        collapse: false,
        members: [],
        errorTypes: [
            'CHALLENGED',
            'REJECTED',
            'EXPIRED',
            'FAILED',
            'DISCONNECTED',
            'LOCKED',
            'DENIED',
            'PREVENTED',
            'IMPEDED',
            'DEGRADED',
            'DISCONTINUED',
            'CLOSED',
            'DISABLED',
            'IMPAIRED',
        ],
        collapsedInstitutions: [],
    }),
    directives: {
        ClickOutside: vClickOutside.directive,
    },
    computed: {
        ...mapState(useWalletStore, ['activeAccount', 'loaded', 'filters']),
        ...mapState(useAppStore, ['userSettings']),
        badMembers() {
            return this.members.filter((member) => {
                return this.errorTypes.includes(member.connection_status);
            });
        },
    },
    methods: {
        ...mapActions(useWalletStore, [
            'setAccountSidebar',
            'setActiveAccount',
        ]),
        userAccountCount(user) {
            let count = 0;
            user.institutions.forEach((el) => {
                count += el.cards ? el.cards.length : 0;
            });

            return count;
        },
        openConnectModal() {
            this.$emit('openConnectModal', this.user);
        },
        getMembers(uuid) {
            ApiService.apiCall('/wallets/members?uuid=' + uuid, 'get')
                .then((response) => {
                    this.members = response.data.members;
                })
                .catch((response) => {
                    this.$root.handleHttpStatus(response);
                });
        },
        hasMemberError(institution) {
            let hasError = false;

            this.badMembers.forEach((member) => {
                if (member.institution_code === institution.code) {
                    hasError = true;
                }
            });

            return hasError;
        },
        updateLocalStorage() {
            const userArray =
                JSON.parse(localStorage.getItem('userTabStates')) || {};

            userArray[this.user.id] = {
                collapsedInstitutions: this.collapsedInstitutions,
            };

            localStorage.setItem('userTabStates', JSON.stringify(userArray));
        },
        handleToggleCollapse(insId) {
            const arrayCopy = [...this.collapsedInstitutions];
            const institution = this.collapsedInstitutions.find(
                (ins) => ins === insId
            );
            if (institution) {
                arrayCopy.splice(
                    this.collapsedInstitutions.indexOf(institution),
                    1
                );
            } else {
                arrayCopy.push(insId);
            }
            this.collapsedInstitutions = arrayCopy;
            this.updateLocalStorage();
        },
    },
    mounted() {
        this.getMembers(this.user.uuid);
    },
    created() {
        const userTabStates =
            JSON.parse(localStorage.getItem('userTabStates')) || {};
        const userSettings = userTabStates[this.user.id];

        if (userSettings && userSettings.collapsedInstitutions) {
            this.collapsedInstitutions = userSettings.collapsedInstitutions;
        }
    },
};
</script>
<style lang="scss" scoped>
@use 'sass:color';

.annual-fee-label-trigger {
    &:hover {
        .annual-fee-label {
            display: block;
        }
    }
}
.annual-fee-label {
    display: none;
    width: 200px;
    padding: 6px 12px;
    color: #fff;
    background-color: #1c293d;
    border-radius: 4px;
    position: absolute;
    bottom: 110%;
    left: 50%;
    margin-left: -100px;
}
.unmatched {
    td {
        background-color: color.adjust(#f8ff73, $lightness: 22%);
    }
}
/*https://codepen.io/ahebler/pen/YXJJWb*/

.tooltip-container .tooltip {
    @apply text-gray-400 xs:max-sm:-ml-1;
}
svg.animated-arrow {
    @apply w-[60px] h-[60px] lg:w-[100px] lg:h-[100px] rotate-[-10deg] lg:rotate-[33deg] -scale-x-100;
    margin: 0 auto;
    .draw-arrow {
        stroke-width: 3;
        stroke: #fd421d;
        fill: none;
        stroke-dasharray: 400;
        stroke-dashoffset: 400;
        animation-duration: 2s;
        animation-delay: 2s;
        animation-fill-mode: forwards;
        animation-name: draw;
        &.tail-1 {
            animation-delay: 2.5s;
        }
        &.tail-2 {
            animation-delay: 2.7s;
        }
    }
}
@keyframes draw {
    to {
        stroke-dashoffset: 0;
    }
}
</style>
